/*globals Stripe*/

// hide the title when scrolling
var scrollPosition;
var halfPoint = $(window).height() / 2;
$(window).on('scroll', function() {
	scrollPosition = $(this).scrollTop();

	if(scrollPosition <= halfPoint) {
		$('.hero h3').css({
			'opacity' : (1 - scrollPosition/halfPoint)
		});
	}
});

// scroll to donation
$('body').on('click', '.to-donate', function() {
    $('html, body').animate({
        scrollTop: $('.donation').offset().top - 250
    }, 700);
    
    return false;
});

// Adjust the amounts
$('body').on('click', '.amount ul li a', function() {
    var $this = $(this);
    $('.amount ul li a').removeClass('active');
    $this.addClass('active');

    $('input[name="amount"]').val($this.data('amount'));

    return false;
});

// in own amount input selected
$('body').on('focus', 'input[name="own"]', function() {
    var $this = $(this);
    $('input[name="amount"]').val($this.val());
    $('.amount ul li a').removeClass('active');
    $this.keyup(function() {
        if($this.val() !== '') {
            // var amount = parseInt($this.val(), 10);
            // amount = isNaN(amount) ? '' : amount;
            $('input[name="amount"]').val($this.val());
            // $this.val(amount);
        } else {
            $('input[name="amount"]').val('0');
        }
    });
});

// show labels
$('body').on('focus', '.fields li input, .fields li textarea', function() {
	var $this = $(this);
	$this.keyup(function() {
		if($this.val() !== '') {
			$this.parent('li').addClass('filled').removeClass('error');
		} else {
			$this.parent('li').removeClass('filled');
		}
	});
});

$('body').on('blur', '.fields li input, .fields li textarea', function() {
    var $this = $(this);
    if($this.val() !== '') {
        $this.parent('li').addClass('filled').removeClass('error');
    } else {
        $this.parent('li').removeClass('filled');
    }
});

// Toggle the honor field
$('#honor').change(function() {
    if($(this).is(':checked')) {
        $('input[name="honoree"]').prop('disabled', false);
        $('input[name="honoree"]').addClass('required');
        $('input[name="honoree"]').focus();
    } else {
        $('input[name="honoree"]').prop('disabled', true);
        $('input[name="honoree"]').removeClass('required');
        $('input[name="honoree"]').val('');
        $('input[name="honoree"]').parents('li').removeClass('filled');
    }
});

// submitting the donation form
$('body').on('submit', '.donation form', function() {
    // var fields = $(this).serializeArray();
    var $this = $(this);
    var error = false;

    $('.donation .required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(parseFloat($('.donation input[name="amount"]').val()) <= 0) {
        showNotice('Donation Error', 'Please select a donation amount', 'Close');
        return false;
    }

    if(error) {
        showNotice('Donation Error', 'Please fill out all required fields', 'Close');
        return false;
    }

    loading('Processing...');
    // create the stripe token
    Stripe.setPublishableKey($('body').attr('data-stripe'));
    Stripe.card.createToken({
        name: $('.donation input[name="first_name"]').val()+' '+$('.donation input[name="last_name"]').val(),
        number: $('.donation input[name="card_number"]').val(),
        cvc: $('.donation input[name="cvv"]').val(),
        exp_month: $('.donation input[name="month"]').val(),
        exp_year: $('.donation input[name="year"]').val(),
        address_line1: $('.donation input[name="street"]').val(),
        address_state: $('.donation input[name="state"]').val(),
        address_zip: $('.donation input[name="zip"]').val()
    }, function(status, response) {
        if(response.error) {
            showNotice('Donation Error', response.error.message, 'Close');
            unloading();
            error = true;
            return false;
        }

        var payload = {};
        payload['_token'] = $('meta[name="csrf-token"]').attr('content');
        payload.stripe_token = response.id;
        payload.first_name = $('.donation input[name="first_name"]').val();
        payload.last_name = $('.donation input[name="last_name"]').val();
        payload.street = $('.donation input[name="street"]').val();
        payload.state = $('.donation input[name="state"]').val();
        payload.zip = $('.donation input[name="zip"]').val();
        payload.email = $('.donation input[name="email"]').val();
        payload.phone = $('.donation input[name="phone"]').val();
        payload.amount = $('.donation input[name="amount"]').val();
        payload.brand = response.card.brand;
        payload.last_four = response.card.last4;
        payload.month = $('.donation input[name="month"]').val();
        payload.year = $('.donation input[name="year"]').val();
        payload.message = $('.donation textarea[name="message"]').val();
        payload.recurring = $('.donation input[name="monthly"]:checked').length ? true : false;
        payload.honoree = !$('input[name="honoree"]').prop('disabled') ? $('input[name="honoree"]').val() : '';
        // console.log(payload);

        loading('Processing...');
        $.ajax({
            type : 'POST',
            url : $this.attr('action'),
            data : payload,
            dataType : 'json',
            success : function(data) {
                unloading();
                // console.log(data);
                if(data.success) {
                    showNotice('Success', data.message, 'close');
                    $('.donation form')[0].reset();
                } else {
                    showNotice('Donation Error', data.message, 'close');
                }
            },
            error : function(request) {
                console.log(request.responseText);
            }
        });

        return false;
    });

    return false;
});